import RouteChecker from './RouteChecker';

export default RouteChecker;
